export default __webpack_public_path__ + "static/media/illustration-algowork-w@3x.5876c307.png";